export const TOGGLE_MODAL_VIP_APPLY = 'TOGGLE_MODAL_VIP_APPLY';

export function toggleModalVipApply() {
  return {
    type: TOGGLE_MODAL_VIP_APPLY,
  };
}
